"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINPill = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var utilities_1 = require("../../utilities");
function PINPill(_a) {
    var className = _a.className, text = _a.text, color = _a.color, children = _a.children, style = _a.style, attr = __rest(_a, ["className", "text", "color", "children", "style"]);
    var aColor = color !== null && color !== void 0 ? color : "moon";
    var isColorName = Object.keys(utilities_1.Colors).includes(aColor);
    var aClassName = "pinpill " + (isColorName ? "color-" + aColor : null) + " " + className;
    var aColorStyle = isColorName
        ? utilities_1.Colors[aColor]
        : aColor;
    return (react_1.default.createElement("div", __assign({ className: aClassName }, attr, { style: __assign(__assign({}, style), { color: aColorStyle, borderColor: aColorStyle, backgroundColor: "" + aColorStyle + Number(25).toString(16) }) }), text || children));
}
exports.PINPill = PINPill;
PINPill.propTypes = {
    color: prop_types_1.default.string,
    text: prop_types_1.default.string,
};
//# sourceMappingURL=PINPill.js.map